/**
 * Locations whose waitlist provider refuses to be embedded, so their
 * `onlineReservationsUrl` has to open in a new tab rather than the iframe modal.
 */
export const DIRECT_LINK_SLUGS = [
  'fishers-in',
  'noblesville-in',
  'indianapolis-in',
  'white-plains-ny'
];

/**
 * @param {string} slug - Location slug
 * @returns {boolean} Whether the location's waitlist must open in a new tab
 */
export const isDirectLinkLocation = (slug) => DIRECT_LINK_SLUGS.includes(slug);
